export default "__VITE_ASSET__bcc98dd2__"